import { download, generateCsv, mkConfig } from "export-to-csv"
import { DateTime } from "luxon"
import { StandardExportButton } from "../../../../../shared/components/table/StandardExportButton"
import { toCurrency, toDinero } from "../../../../currency/currencyLib"
import { useMoney } from "../../../../currency/useMoney"
import { useDateTime } from "../../../../localization/useDateTime"
import { UserBalance } from "../accountingApi"
import { useCallback } from "react"

type ExportButtonCustomerBalanceProps = Readonly<{
    data: UserBalance[]
    startDate?: DateTime
    endDate?: DateTime
}>
export function ExportButtonCustomerBalance({ data, startDate, endDate }: ExportButtonCustomerBalanceProps) {
    const dateTimeFactory = useDateTime()
    const moneyFactory = useMoney({})

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ".",
        useBom: true,
        useKeysAsHeaders: true,
        ...(startDate && endDate
            ? {
                  filename: `Facilitynet-Customer-Balance-${dateTimeFactory.formatDate(
                      startDate,
                  )}_${dateTimeFactory.formatDate(endDate)}`,
              }
            : { filename: "Facilitynet-Customer-Balance" }),
    })

    const mapUserBalanceToCsvRow = (userBalance: UserBalance) => ({
        // ...(startDate && { From: dateTimeFactory.formatDate(startDate) }),
        // ...(endDate && { To: dateTimeFactory.formatDate(endDate) }),
        "Employee Id": userBalance?.user?.employeeId ?? "",
        Name: userBalance?.user.displayName ?? "",
        Email: userBalance?.user?.email ?? "",
        [`Amount (${moneyFactory.getLocalizedCurrencySymbol(
            toCurrency(userBalance?.totalAmount?.currency ?? "DKK"),
        )})`]: userBalance?.totalAmount ? moneyFactory.formatAsNumber(toDinero(userBalance.totalAmount)) : "",
    })

    const handleExportRows = useCallback(
        (data: UserBalance[] | null | undefined) => {
            let exportRows: ReturnType<typeof mapUserBalanceToCsvRow>[]

            if (data && data.length > 0) {
                exportRows = data.map((userBalance) => mapUserBalanceToCsvRow(userBalance))
            } else {
                exportRows = [mapUserBalanceToCsvRow({} as UserBalance)]
            }

            const csv = generateCsv(csvOptions)(exportRows)
            download(csvOptions)(csv)
        },
        [dateTimeFactory, moneyFactory, data, startDate, endDate],
    )

    return <StandardExportButton onClick={() => handleExportRows(data)} />
}
